




import {Component, Vue} from 'vue-property-decorator';

@Component
export default class LoginButton extends Vue {
  private login(): void {
    this.$gapi.login().then(() => {
      location.reload();
    });
  }
}
